// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/audit-trail/audit-trail.less
// module id = 3872
// module chunks = 0